export default class TimeLag {
  callback: (params: any) => void;
  lag: number;
  params: any;
  id: any;
  breakNum: number = 0;
  constructor(callback: (params: any) => void, lag) {
    this.callback = callback;
    this.lag      = lag;
  }
  public start(params = undefined){
    this.params = params;
    if(this.id){ this.breakNum += 1;}
    this.clear();
    this.id = setTimeout( () => this.timeout(), this.lag);
  }
  public clear() {
    if( this.id ) { clearTimeout(this.id)}
    this.id = undefined;
  }
  public timeout() {
    this.clear();
    this.callback(this.params);
    this.breakNum = 0;
  }
  public destroy(){
    this.clear();
    this.breakNum = 0;
  }
  public number(){
    return this.breakNum + 1;
  }
}
